<nav>
  <a [ngClass]="{ 'dropdown-active': menuItemDropdown }" class="dropdown-button" (click)="toggleMenuItemDropdown()"><span>Apps</span></a>
  <div class="dropdown">
    <a href="apps/anatomy" routerLinkActive="active" (click)="toggleMenu.emit({})" (click)="toggleMenuItemDropdown()"><span>Anatomy</span></a>
    <a href="apps/elements" routerLinkActive="active" (click)="toggleMenu.emit({})" (click)="toggleMenuItemDropdown()"><span>Elements</span></a>
  </div>
  <a href="/stem" routerLinkActive="active" (click)="toggleMenu.emit({})"><span>STEM</span></a>
  <a href="/lessons" routerLinkActive="active" (click)="toggleMenu.emit({})"><span>Lessons</span></a>
  <a href="/guides" routerLinkActive="active" (click)="toggleMenu.emit({})"><span>Guides</span></a>
  <a href="/contact" routerLinkActive="active" (click)="toggleMenu.emit({})"><span>Contact</span></a>
</nav>
